import { getParamsUrl } from '@/helpers/request'
import Repository from './Repository'

const action = 'contragents'
const actionEDC = 'pc-api-users'

export default {
  findContragents(search) {
    return Repository.get(
      action + '?search=' + search + '?master_approve_status=1',
    )
  },
  findContragentsByInn(inn) {
    return Repository.get(action + '?inn=' + inn)
  },

  contragents(settings = {}) {
    return Repository.get('pages/' + action + getParamsUrl(settings))
  },
  getByGroup(id) {
    return Repository.get(`${action}?contragent_group_id=${id}`)
  },
  get(id) {
    return Repository.get(action + '/' + id)
  },
  getContragentByInn(inn) {
    return Repository.get('pages/' + action + `?inn=${inn}`)
  },
  putContragents(contragent) {
    return Repository.put(action + '/' + contragent.id, contragent)
  },
  postContragents(contragent) {
    return Repository.post(action, contragent)
  },
  deleteContragents(id) {
    return Repository.delete(action + '/' + id, {
      id,
    })
  },
  getEDC(inn) {
    return Repository.get(`${actionEDC}?org_inn=${inn}`)
  },
  getStatutoryDocumentsList(id) {
    return Repository.get(`${action}/get-docs-state?id=${id}`)
  },
  setStatutoryDocuments(params) {
    return Repository.post(`${action}/set-docs-state`, params)
  },
}
